import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { SelectionLists, SiteCodes, Task5Model } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-config-add-take',
  templateUrl: './config-add-take.component.html',
  styleUrls: ['./config-add-take.component.css']
})
export class ConfigAddTakeComponent implements OnInit {
  _dropDownLists: SelectionLists = new SelectionLists();

  constructor(
    public dialogRef:MatDialogRef<ConfigAddTakeComponent>, 
    private _safetyConfigService:SafetyConfigService,
    public toastr: NotificationsService, vcr: ViewContainerRef
  ) { }


 //current date
 mydate =new Date();
 
  Task5Model:Task5Model;
  siteCodesList: SiteCodes[]=[];
  

  inputValueMonth:number;
  inputValueYear:number;
  inputValuenumber:number=0;
  inputValuestate:number;

  ngOnInit() {
    this.inputValueYear=this.mydate.getFullYear(); 
    this.inputValueMonth=this.mydate.getMonth() +1;
    console.log('year' + this.inputValueYear, this.inputValueMonth)
    this.loadSiteList();

  }

  state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }

 loadSiteList()
 {
   this._safetyConfigService.getAllSitesList().subscribe(sites =>
   { 
     console.log('sitelist',sites)
     this.siteCodesList=sites;
     
   });
 }
  DialogClose(){
    this.dialogRef.close(false)
  }

  addTake5()
  {
    console.log('month' , this.inputValueMonth)
    console.log('year' , this.inputValueYear)
    console.log('number' , this.inputValuenumber)
    let model=new Task5Model();
    model.inputValueMonth=this.inputValueMonth;
    model.inputValueYear=this.inputValueYear;
    model.inputValuenumber=this.inputValuenumber;
    model.inputValuestate=this.inputValuestate;
    this._safetyConfigService.addTake5(model).subscribe(r=>
      {
        console.log("result", r)
        // if(r=true){
        //   this.toastr.success('Saved');
        //   }
        //   else{
        //     this.toastr.error('Error');
        //   }

      })
    
    this.DialogClose();
  }
}
